import { ServiceSettingSuggestionStore } from './service-setting-suggestion.store';
import { fb } from '../../../../../../../../packages/client/src/app/modules/shared/shared.global-service';
import { Component, inject } from '@angular/core';
import { SERVICE_SETTINGS_SUGGESTION_TYPE_KEY } from '@libs/types/src/services/types/common-service-settings.type';
import {
    ServiceSettingsCommonComponent,
} from '../../../../modules/content/components/services/settings/service-settings-common/service-settings-common.component';
import { ServiceComplaintTypeComponent } from './service-complaint-type/service-complaint-type.component';

@Component({
    selector: 'app-service-setting-suggestion',
    templateUrl: './service-setting-suggestion.component.html',
    styleUrl: './service-setting-suggestion.component.scss',
    providers: [ServiceSettingSuggestionStore],
    imports: [
        ServiceSettingsCommonComponent,
        ServiceComplaintTypeComponent,
    ],
})
export class ServiceSettingSuggestionComponent {

    public readonly store = inject(ServiceSettingSuggestionStore);

    protected form = fb.group({});

    protected readonly SERVICE_SETTINGS_SUGGESTION_TYPE_KEY = SERVICE_SETTINGS_SUGGESTION_TYPE_KEY;
}
